import type { Filter } from './filter';

export class FilterDefinition<E, T extends Filter<E>> {
    protected defaultValueGetter: () => E;

    get hasDefaultValue(): boolean {
        return !!this.defaultValueGetter;
    }

    constructor(public readonly name: string,
                public readonly filterClass: (new (value: any) => T)) {
    }

    buildFilter(value: any): Filter<any> {
        return new this.filterClass(value);
    }

    withDefaultValue(valueGetter: () => E): this {
        this.defaultValueGetter = valueGetter;
        return this;
    }

    defaultValue(): E {
        return this.defaultValueGetter?.();
    }
}
